import { Card } from 'components/atoms';
import { FormInput } from 'components/molecules';
import TotalCard from 'components/molecules/card/total/TotalCard';

import ListWrapper from 'components/molecules/list-wrapper/ListWrapper';

import { QueryFilter, TopBar } from 'components/organisms';
import QueryFilterLabels from 'components/organisms/filters/query-form/labels/QueryFilterLabels';
import { TopbarPage } from 'components/templates';
import { useScroll } from 'components/templates/application/ApplicationTemplate';
import { useComponentVisible } from 'hooks';

import { useTableColumnsVisibility } from 'hooks/useTableColumnsVisibility';
import { useStoreState } from 'providers/StoreStateContext';

import { useTranslation } from 'react-i18next';

import { useNavigate } from 'react-router-dom';
import { useGetAdvancesByLabelInfinite } from 'services/advance';
import { useGetSettlementPeriodsLightList } from 'services/settlement';
import { IStatementsSearch } from 'services/settlement/types';

import { formatCurrency } from 'utils/global/currency.utils';
import { getSettlementPeriodName } from 'utils/global/name.utils';

enum SORT_COLUMNS {
  date,
  description,
  forSignature,
  amount,
  repaymentForAllContracts,
  remainingNetAmount,
}

const statementsSearchInitialValues: IStatementsSearch = {
  startSettlementPeriodId: '',
  endSettlementPeriodId: '',
};

const Advance = () => {
  // const advances = useGetAdvancesByLabelInfinite();

  const columnsVisibility = useTableColumnsVisibility('AdvanceList1', SORT_COLUMNS);

  const { searchById, setSearchById } = useStoreState();
  const filters = searchById[columnsVisibility.tableId] || statementsSearchInitialValues;

  const { data, isLoading, fetchNextPage, isFetchingNextPage, statistics } =
    useGetAdvancesByLabelInfinite(filters);

  const scroll = useScroll({ fetchNextPage: fetchNextPage });

  const { ref, isComponentVisible, handleComponentVisible } =
    useComponentVisible<HTMLDivElement>(false);

  const i18nextPrefix = 'advance';
  // const tableProps = useInfiniteTable(advances);

  const settlementPeriods = useGetSettlementPeriodsLightList();

  const settlementPeriodOptions = settlementPeriods.data?.flat().map((s) => ({
    label: getSettlementPeriodName(s.settlementPeriodName),
    value: s.id,
  }));

  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <TopbarPage
      topbarAbsolute
      footer={
        <TotalCard
          header={t('table.left')}
          content={formatCurrency(statistics?.allRemainingNetAmount)}
        />
      }
      topbar={
        <TopBar
          size="compact"
          title={t(`${i18nextPrefix}.title.list`)}
          path=""
          customBackItem={<div />}
          topbarContent={
            <>
              {/* <div className="flex">
                <QueryFilter.ButtonOpener
                  i18nextPrefix={i18nextPrefix}
                  onClick={handleComponentVisible}
                  variant={BUTTON_VARIANT.default}
                  isClear
                />
              </div> */}
            </>
          }
        >
          {' '}
          <QueryFilter<IStatementsSearch> i18nextPrefix={i18nextPrefix} initialValues={filters}>
            <>
              <QueryFilter.Form<IStatementsSearch>
                ref={ref}
                isOpen={isComponentVisible}
                onDebouncedFormChange={(values) => setSearchById(columnsVisibility.tableId, values)}
              >
                <QueryFilter.InputsGrid>
                  <FormInput.Select
                    name="startSettlementPeriodId"
                    label={t('input.label.startSettlementPeriod')}
                    placeholder=""
                    options={settlementPeriodOptions}
                  />
                  <FormInput.Select
                    name="endSettlementPeriodId"
                    placeholder=""
                    label={t('input.label.endSettlementPeriod')}
                    options={settlementPeriodOptions}
                  />
                </QueryFilter.InputsGrid>
              </QueryFilter.Form>
              <QueryFilterLabels scope="advance" isFormOpen={isComponentVisible} />
            </>
          </QueryFilter>
        </TopBar>
      }
    >
      <ListWrapper
        view="list"
        style={{ paddingBottom: 100 }}
        items={data?.pages.flat()}
        isLoading={isLoading}
        isFetchingNextPage={isFetchingNextPage}
        item={(advance) => (
          <Card
            view="list"
            key={advance.id}
            description={advance.advanceNumber}
            header={advance.description}
            onClick={() => navigate(`${advance.id}/repayments`)}
            status={
              <div className="flex flex-col w-max items-end ">
                <p className=" font-bold" style={{ fontSize: 18 }}>
                  {formatCurrency(advance.remainingNetAmount)}
                </p>
                <p className="opacity-65">{formatCurrency(advance.amount)}</p>
              </div>
            }
          />
        )}
      />
      {/* <FooterTable
        id={'advanceLabel'}
        {...tableProps}
        data={{
          nodes: tableProps.data.nodes.map(d => ({
            ...d,
            id: `${d.id}/repayments`,
          })),
        }}
        size='compact'
        displayMode
        columns={[
          {
            label: t('input.label.date'),
            renderCell: item => (
              <TableItem>
                <TableItem.Text text={formatDate(item.date)} />
              </TableItem>
            ),
            resize: true,
            hide: columnsVisibility.hide(SORT_COLUMNS.date),
            footer: t('table.total'),
          },
          {
            label: t('input.label.description'),
            renderCell: item => (
              <TableItem>
                <TableItem.Text text={`${item.description}`} />
              </TableItem>
            ),
            hide: columnsVisibility.hide(SORT_COLUMNS.description),
            resize: true,
          },
          {
            label: t('input.label.signature'),
            renderCell: item => (
              <TableItem>
                <LabelSignatureStatus
                  status={
                    item.forSignature
                      ? SIGNATURE_TYPE.true
                      : SIGNATURE_TYPE.false
                  }
                />
              </TableItem>
            ),
            hide: columnsVisibility.hide(SORT_COLUMNS.forSignature),
            resize: true,
          },
          {
            label: t('input.label.amount'),
            renderCell: item => (
              <TableItem>
                <TableItem.Currency
                  text={formatCurrency(item.amount, {
                    length: totalValueLength,
                  })}
                />
              </TableItem>
            ),
            resize: true,
            hide: columnsVisibility.hide(SORT_COLUMNS.amount),
            footer: formatCurrency(advanceStatistic.data?.allAmount, {
              length: totalValueLength,
            }),
          },
          {
            label: t('input.label.remainingNetAmount'),
            renderCell: item => (
              <TableItem>
                <TableItem.Currency
                  text={formatCurrency(item.remainingNetAmount, {
                    length: totalValueLength,
                  })}
                />
              </TableItem>
            ),
            resize: true,
            hide: columnsVisibility.hide(SORT_COLUMNS.remainingNetAmount),
            footer: formatCurrency(
              advanceStatistic.data?.allRemainingNetAmount,
              {
                length: totalValueLength,
              }
            ),
          },
          {
            label: t('input.label.repaymentsFromAllContracts'),
            renderCell: (item: any) => (
              <TableItem>
                <LabelBoolen
                  status={
                    item.repaymentsFromAllContracts
                      ? REPAYMENTS_TYPE.true
                      : REPAYMENTS_TYPE.false
                  }
                />
              </TableItem>
            ),
            hide: columnsVisibility.hide(SORT_COLUMNS.repaymentForAllContracts),
            resize: true,
          },
        ]}
      /> */}
    </TopbarPage>
  );
};

export default Advance;
